import { createContext } from "react";

/**
 * Mode context for the playbook step editors: in the V2 editor `v2NodeId` is
 * the canvas node id and step fields offer upstream-variable chips
 * (`:var[...]`, engine-resolved); in V1 it stays null and chips are the
 * declared input variables (`{{var}}`). `listInputVariableNames` are the V1
 * input variables declared with a list type, offered where a step field
 * expects a list (e.g. the loop step's items).
 */
export const PlaybookEditorContext = createContext<{
  v2NodeId: string | null;
  listInputVariableNames: string[];
}>({ v2NodeId: null, listInputVariableNames: [] });
